export class StacLink {
    public href: string;
    public rel: string;
    public type: string|undefined;
    public title: string|undefined;

    constructor(href:string, rel:string, type:string|undefined, title:string|undefined) {
        this.href = href;
        this.rel = rel;
        this.type = type;
        this.title = title;
    }

    static parse(data:any): StacLink|null {
        if (data.href && data.rel) {
            return new StacLink(data.href, data.rel, data.type, data.title);
        }
        return null;
    }
}